import Logo from "../../images/flydoc.svg";
import Paid from "../../images/paids.svg";
import logo from "../../images/logo.png";

function Printhead() {
  return (
    <div
      class="row pt-2 dtranHeader mx-auto print-hide"
      style={{ position: "fixed", top: 0, left: 0, right: 0 }}
    >
      <div
        class="d-flex justify-content-start align-items-center col-lg-6"
        style={{ gap: "0.5rem" }}
      >
        <img src={logo} class="inimg" alt="..." />
        <div class="d-flex flex-column justify-content-start">
          <span style={{ fontWeight: "600", fontSize: "22px" }}>
            Club Travel Service
          </span>
          <span style={{ fontWeight: "600", fontSize: "18px" }}>
            Hajj License No: 720
          </span>{" "}
        </div>
      </div>

      <div class="col-lg-6 text-right mt-3" style={{ fontSize: 14 }}>
        <p class="m-0">
          <i class="fa fa-globe" aria-hidden="true"></i>{" "}
          {process.env.REACT_APP_ADDRESS}
          <br></br> {process.env.REACT_APP_ADDRESS2}
        </p>
        <p class="m-0">
          <i class="fa fa-phone" aria-hidden="true"></i>{" "}
          <span> {process.env.REACT_APP_PHONE}</span>
        </p>
      </div>

      <hr />
    </div>
  );
}

export default Printhead;
